import React, { forwardRef } from 'react';
import {
  FormControl as MuiFormControl,
  type FormControlProps,
} from '@mui/material';

export type { FormControlProps };

// forwards the ref so wrappers like Base UI's number field can reach the root
const FormControl = forwardRef<HTMLDivElement, FormControlProps>(
  ({ children, ...props }, ref) => (
    <MuiFormControl ref={ref} {...props}>
      {children}
    </MuiFormControl>
  )
);

FormControl.displayName = 'FormControl';

export default FormControl;
